import * as React from "react";

const UploadImageIcon = (props) => (
	<svg
		width={57}
		height={56}
		viewBox="0 0 57 56"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			opacity={0.4}
			d="M38.61 51.334H18.388c-7.909 0-13.221-5.547-13.221-13.804V18.473c0-8.257 5.312-13.806 13.22-13.806h20.225c7.908 0 13.221 5.549 13.221 13.806V37.53c0 8.257-5.312 13.804-13.223 13.804"
			fill="#647DFF"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M26.738 20.242a5.806 5.806 0 0 1-5.798 5.798 5.804 5.804 0 0 1-5.798-5.798c0-3.197 2.599-5.8 5.798-5.8a5.81 5.81 0 0 1 5.798 5.8m19.03 12.63a5.1 5.1 0 0 1 1.19 1.77c.776 1.942.373 4.275-.458 6.198a8.49 8.49 0 0 1-5.245 4.774c-1.055.338-2.16.483-3.265.483H18.435c-1.946 0-3.668-.453-5.08-1.302-.884-.532-1.04-1.757-.385-2.555 1.097-1.33 2.18-2.665 3.271-4.011 2.082-2.576 3.484-3.323 5.043-2.667.632.27 1.267.679 1.92 1.108 1.74 1.153 4.16 2.735 7.348 1.017 2.178-1.19 3.443-3.23 4.544-5.004l.022-.035.22-.356c.375-.605.744-1.2 1.161-1.75.518-.678 2.441-2.802 4.926-1.29 1.585.953 2.917 2.24 4.343 3.62"
			fill="#647DFF"
		/>
	</svg>
);
export default UploadImageIcon;
